import { render, staticRenderFns } from "./inboundstock.vue?vue&type=template&id=951edc1c&scoped=true&"
import script from "./inboundstock.vue?vue&type=script&lang=js&"
export * from "./inboundstock.vue?vue&type=script&lang=js&"
import style0 from "./inboundstock.vue?vue&type=style&index=0&id=951edc1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951edc1c",
  null
  
)

export default component.exports